export const managerProfileConstants = {
  MANAGERS_DATA: "MANAGERS_DATA",
  MANAGERS_DETAIL: "MANAGERS_DETAIL",
  PAGINATED_MANAGERS_DATA: "PAGINATED_MANAGERS_DATA",
  OR: " OR ",
  AND: " AND ",
  NAME: "name",
  STATE: "state",
};
